(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["delivery-countdown"] && !Shopify.designMode) return;
  try {
    class DeliveryCountdown extends HTMLElement {
    connectedCallback() {
      this.titleEl = this.querySelector('.delivery-countdown__title');
      this.messageEl = this.querySelector('.delivery-countdown__message');
      this.countdownEl = this.querySelector('.delivery-countdown__countdown');

      this.cutoffHour = parseFloat(this.dataset.cutoffHour);
      this.hideCountdown = this.dataset.hideCountdown === 'true';

      this.render();

      if (!this.hideCountdown) {
        this.interval = setInterval(() => this.render(), 1000 * 30);
      }
    }

    disconnectedCallback() {
      clearInterval(this.interval);
    }

    render() {
      const now = new Date();
      const currentHour = now.getHours() + now.getMinutes() / 60;
      const pastCutoff = currentHour >= this.cutoffHour;

      this.classList.toggle('delivery-countdown--past-cutoff', pastCutoff);
      this.titleEl.textContent = pastCutoff ? this.dataset.nextDayTitle : this.dataset.sameDayTitle;

      const message = pastCutoff ? this.dataset.nextDayMessage : this.dataset.sameDayMessage;
      let countdownValue = '';

      if (!pastCutoff && !this.hideCountdown) {
        const cutoffTime = new Date(now.getFullYear(), now.getMonth(), now.getDate(), Math.floor(this.cutoffHour), Math.round((this.cutoffHour % 1) * 60));
        const diff = Math.max(cutoffTime - now, 0);
        const hours = Math.floor(diff / 1000 / 60 / 60);
        const minutes = Math.floor(diff / 1000 / 60) % 60;
        countdownValue = `${hours} ${this.dataset.hoursText} ${minutes} ${this.dataset.minutesText}`;
      }

      if (message.includes('[[countdown]]')) {
        this.messageEl.textContent = message.replace('[[countdown]]', countdownValue);
        this.countdownEl.textContent = '';
      } else {
        this.messageEl.textContent = message;
        this.countdownEl.textContent = countdownValue ? `${countdownValue} ${this.dataset.cutoffText}` : '';
      }
    }
  }

  if (!customElements.get('delivery-countdown')) {
    customElements.define('delivery-countdown', DeliveryCountdown);
  }
  } catch(e) { console.error(e); }
})();

})();
